import { gql } from "@apollo/client";

export const AssetSubAssetCount = gql`
    query AssetSubAssetCount ($id: ID!) {
        assetLocation (id: $id) {
            id
            installedBaseNode {
                id
                assetCount
            }
        }
    }
`;
